/* Full-screen loading overlay with the rotating BEST logo. Blocks all interaction
 * while shown (used during NAP-details fetches and job-order completion). */
export default function FetchingOverlay({ show = true }) {
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-[10050] flex items-center justify-center bg-black/20">
      <div className="relative flex items-center justify-center w-20 h-20">
        {/* Rotating hexagon border */}
        <svg
          className="absolute inset-0 w-full h-full animate-spin"
          style={{ animationDuration: "1.5s" }}
          viewBox="0 0 100 100"
          fill="none"
        >
          <polygon
            points="50,2 93,25 93,75 50,98 7,75 7,25"
            stroke="#2563eb"
            strokeWidth="4"
            fill="none"
            strokeLinecap="round"
            strokeDasharray="12 6"
          />
        </svg>
        {/* Static icon */}
        <img src="/best-icon.png" alt="Loading..." className="h-12 w-12" />
      </div>
    </div>
  );
}
